import React from "react";

import { REGENERUS_TERMS_AND_CONDITIONS_SLUG } from "@/core/urls";
import PolicyPage from "./PolicyPage";

function RegenerusTermsAndConditionsPage() {
  return <PolicyPage slug={REGENERUS_TERMS_AND_CONDITIONS_SLUG} />;
}

export default RegenerusTermsAndConditionsPage;
